import React from 'react';
import { Circle, Path, Svg } from 'react-native-svg';

interface IconProps {
  size?: number;
  color?: string;
}

export const SolarMenuDotsIcon: React.FC<IconProps> = ({ size = 24, color = 'black' }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <Path
      d="M5 14C6.10457 14 7 13.1046 7 12C7 10.8954 6.10457 10 5 10C3.89543 10 3 10.8954 3 12"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <Circle
      cx="12"
      cy="12"
      r="2"
      stroke={color}
      strokeWidth="1.5"
    />
    <Path
      d="M21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12C17 10.8954 17.8954 10 19 10"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Svg>
);
